import { IonContent, IonPage } from '@ionic/react';
import { SignIn } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';
import revLogo from '../assets/REV_logo.svg';
import revLogoWhite from '../assets/REV_logo_white.svg';

export const SignInPage: React.FC = () => {
  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div className="flex items-center px-4 py-4">
          <Link to="/" className="flex items-center">
            <img src={revLogo} alt="REV Logo" className="h-8 w-auto dark:hidden" />
            <img src={revLogo} alt="REV Logo" className="h-8 w-auto hidden dark:block" />
          </Link>
        </div>
        <div className="flex items-center justify-center min-h-full">
          <SignIn 
            routing="virtual"
            signUpUrl="/sign-up"
            appearance={{
              elements: {
                footerAction: { display: "none" }  // Hides the footer with sign up link
              }
            }}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};